export default __webpack_public_path__ + "static/media/NotLogged2.2c1ca6f8.svg";